
      const login = {
  "account": "Аккаунт",
  "password": "Пароль",
  "rememberAccount": "Запомнить аккаунт",
  "accountTip": "Введите номер аккаунта",
  "smsLogin": "Вход по SMS",
  "accountLogin": "Вход в аккаунт",
  "passwordTip": "Введите пароль",
  "verifyCode": "Проверочный код",
  "verifyCodeTip": "Введите проверочный код",
  "verifyCodeLengthTip": "Длина проверочного кода - 4 символа",
  "phoneNumber": "Номер телефона",
  "login": "Вход",
  "smsVerifyCode": "Проверочный SMS код",
  "sendSms": "Отправить SMS",
  "loginSuccess": "Успешный вход",
  "welcome": "Добро пожаловать!",
  "phoneNumberFormatError": "Неправильный формат номера телефона",
  "verifyCodeLengthError": "Неверная длина проверочного кода",
  "verifyCodeIsNull": "Пожалуйста введите проверочный код",
  "sendAgain": "Отправить повторно",
  "intelligentPositionSystem":"Интеллектуальная система определения местоположения",
  "beian":"Пекин ICP 16017149 - 1",
  "usernameOrPasswordError": "Ошибка имени пользователя или пароля",
}
      export default login
    